// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Ebookviewer_Wrapper__2s8pH","Back":"Ebookviewer_Back__35iCO","Iframe":"Ebookviewer_Iframe__3_enl"};